import { render, staticRenderFns } from "./Url.vue?vue&type=template&id=44980327&"
import script from "./Url.vue?vue&type=script&lang=js&"
export * from "./Url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports